import React from 'react';
import { GroupHeader, GroupHeaderProps } from '@clds/menu';

export const GroupHeading = (props: GroupHeaderProps) => <GroupHeader tone="highContrast" data-testid="combobox-group-heading" {...props} />;
